export default "__VITE_ASSET__DLB6mHeO__"